define([
	"./_TextStyle",
	"./PluginFactory"
], function(_TextStyle,PluginFactory) {

	return PluginFactory.declare(_TextStyle, {
		"class": "csi-button-toggle",
		cssValue: "u",
		materialIcon: "format_underlined",
		pluginName: "underline",
		title: "CanvasUnderline"
	});
});
